import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/fittin/Nav";
import Hero from "@/components/fittin/Hero";
import HowItWorks from "@/components/fittin/HowItWorks";
import ForCompanies from "@/components/fittin/ForCompanies";
import RetailerMCPDemo from "@/components/fittin/RetailerMCPDemo";
import ValueProp from "@/components/fittin/ValueProp";
import IntegrationDemo from "@/components/fittin/IntegrationDemo";
import SilentUX from "@/components/fittin/SilentUX";
import ContactForm from "@/components/fittin/ContactForm";
import Footer from "@/components/fittin/Footer";

export default function CompaniesPage() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main
      data-testid="companies-page"
      className="relative min-h-screen bg-[#FAFAFA] text-[#0A0A0A] overflow-x-hidden"
    >
      <Nav />
      <Hero variant="company" />
      <HowItWorks />
      <ForCompanies />
      <RetailerMCPDemo />
      <ValueProp />
      <IntegrationDemo />
      <SilentUX />
      <ContactForm />
      <Footer />
    </main>
  );
}
